import React from 'react'
import CreateEditProjectForm from '../components/Projects/CreateEditProjectForm'
import { useParams } from 'react-router-dom'
const UpdateProject = () => {
    const {projectId} = useParams();
    return <CreateEditProjectForm mode={'edit'} projectId={projectId} />
}

export { UpdateProject }